<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="4">
                      <TextBox v-model="item.title" placeholder="Title"
                               :addClass="{'is-invalid': $v.item.title.$error}">Title</TextBox>
                    </b-col>
                    <b-col sm="2">
                      <TextBox v-model="item.points" placeholder="0"
                               :addClass="{'is-invalid': $v.item.points.$error}">Points</TextBox>
                    </b-col>
                    <b-col sm="2">
                      <TextBox v-model="item.seconds" placeholder="0"
                               :addClass="{'is-invalid': $v.item.seconds.$error}">Each Question Seconds</TextBox>
                    </b-col>
                    <b-col sm="2">
                      <TextBox v-model="item.totalMinutes" placeholder="0"
                               :addClass="{'is-invalid': $v.item.totalMinutes.$error}">Total Quiz Time(min)</TextBox>
                    </b-col>
                    <b-col sm="2">
                      <TextBox v-model="item.maxQuestionCount" placeholder="0"
                               :addClass="{'is-invalid': $v.item.maxQuestionCount.$error}">Limit Questions</TextBox>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="8">
                      <Textarea v-model="item.description" rows="5" placeholder="Description"
                               :addClass="{'is-invalid': $v.item.description.$error}">Description</Textarea>
                    </b-col>
                    <b-col sm="4">
                      <b-row>
                        <b-col sm="8">
                          <DatePicker v-model="item.endDate"
                                      :addClass="{'is-invalid': $v.item.endDate.$error}">End Date</DatePicker>
                        </b-col>
                        <b-col sm="4">
                          <TextBox v-model="time" type="time">End Time</TextBox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <TextBox v-model="item.resultsChannel" placeholder="@channelName">Results channel</TextBox>
                        </b-col>
                        <b-col sm="6">
                          <TextBox v-model="item.freeChances" placeholder="0" type="number">Free chances</TextBox>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <b-button right type="submit" variant="primary" @click="onSubmit">Save</b-button>
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/quiz'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> Additional chances by
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse2" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="12">
                      <b-form-radio v-model="smsActivation" name="radios" :value="true">Sms Activation</b-form-radio>
                      <b-form-radio v-model="smsActivation" name="radios" :value="false">Channel Activation</b-form-radio>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
      <b-row v-if="hasChannelActivation">
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> Channels to Subscribe
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse3>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse3" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="12">
                      <table class="table table-bordered table-sm">
                        <thead class="thead-light">
                        <tr>
                          <th width="50%" scope="col">Channel Name</th>
                          <th width="15%" scope="col"># of chances</th>
                          <th width="15%" scope="col">Order</th>
                          <th width="10%" scope="col" class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(channel, index) in channels" :key="index">
                          <td>
                            <b-form-input v-model="channel.channelName"
                                          size="sm" placeholder="@channelName">
                            </b-form-input>
                          </td>
                          <td>
                            <b-form-input v-model="channel.actionLimit"
                                          size="sm" placeholder="1">
                            </b-form-input>
                          </td>
                          <td>
                            <b-form-input v-model="channel.sorder"
                                          size="sm" type="number">
                            </b-form-input>
                          </td>
                          <td class="text-center">
                            <b-button variant="danger" size="sm" @click="removeAnswer(channel)"><i class="icon-close"></i></b-button>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center">
                            <b-button variant="success" size="sm" @click="addNewRow"><i class="icon-plus"></i> New Item</b-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators'

export default {
  name: 'QuizAddEditPage',
  data () {
    return {
      item: {},
      smsActivation: false,
      time: null,
      channels: []
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      this.item.freeChances = 2
      return
    }
    this.$loading.show()
    this.axios.get('quiz/item', {params: {id: this.$route.params.id}})
      .then(response => {
        this.item = response.data.data
        if (this.item && this.item.endDate) {
          this.time = this.getTimeFormat(this.item.endDate)
          this.item.endDate = new Date(this.item.endDate)
        }
        this.smsActivation = this.item.smsActivation
        if (this.item.activationChannels) {
          this.channels = this.item.activationChannels.map(channelItem => ({
            id: channelItem.id,
            channelName: channelItem.channelName,
            actionLimit: channelItem.actionLimit,
            sorder: channelItem.sorder
          }))
        }
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  computed: {
    pageName () {
      return this.$route.params.id ? 'Edit Quiz' : 'Add Quiz'
    },
    hasChannelActivation () {
      return !this.smsActivation
    }
  },
  methods: {
    onSubmit () {
      if (this.$v.item.$invalid) {
        this.$v.$touch()
        return
      }
      if (this.time) {
        this.item.endDate.setHours(this.time.split(':')[0], this.time.split(':')[1])
      }
      this.item.smsActivation = this.smsActivation
      if (this.channels && this.channels.length > 0) {
        this.item.activationChannels = this.channels.map(channel => ({
          id: channel.id,
          channelName: channel.channelName,
          actionLimit: channel.actionLimit,
          sorder: channel.sorder
        }))
      } else {
        this.item.activationChannels = []
      }
      this.$loading.show()
      let axios
      if (this.item.id) {
        axios = this.axios.put('quiz/item', this.item)
      } else {
        axios = this.axios.post('quiz/item', this.item)
      }
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/quiz')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    },
    getTimeFormat (dateString) {
      const date = new Date(dateString)
      let hour = '0'
      if (date.getHours() < 10) {
        hour += date.getHours()
      } else {
        hour = date.getHours()
      }
      let minute = '0'
      if (date.getMinutes() < 10) {
        minute += date.getMinutes()
      } else {
        minute = date.getMinutes()
      }
      return hour + ':' + minute
    },
    removeAnswer (item) {
      const itemIndex = this.channels.indexOf(item)
      if (itemIndex !== -1) {
        this.channels.splice(itemIndex, 1)
      }
    },
    addNewRow () {
      const order = this.channels.length + 1
      const _channelIds = this.channels.length > 1 ? Math.max(...this.channels.map(channel => {
        return channel.id ? channel.id : 1
      })) : 1
      this.channels.push({
        id: (_channelIds || 1) + 1,
        channelName: '',
        actionLimit: 1,
        sorder: order
      })
    }
  },
  validations: {
    item: {
      title: {
        required
      },
      seconds: {
        required,
        integer
      },
      points: {
        required
      },
      totalMinutes: {
        required,
        integer
      },
      maxQuestionCount: {
        required,
        integer
      },
      description: {
        required
      },
      endDate: {
        required
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/quiz/QuizAddEditPage.vue